export default "__VITE_ASSET__DLoIiIHJ__"